module.exports = "pegasus_template/assets/themelp1/tickets/bg.png";